export class ApiRequestError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
  ) {
    super(message);
  }
}

export function idempotencyKey() {
  return crypto.randomUUID();
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && typeof init.body === "string" && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const response = await fetch(path, { ...init, headers });
  let payload: any = null;
  try { payload = await response.json(); } catch { /* response may be empty */ }
  if (!response.ok || payload?.status === "error") {
    throw new ApiRequestError(
      payload?.message || `Request failed (${response.status})`,
      response.status,
      payload?.code,
    );
  }
  return payload as T;
}

export function postJson<T>(path: string, body: unknown, key = idempotencyKey()) {
  return api<T>(path, {
    method: "POST",
    headers: { "idempotency-key": key },
    body: JSON.stringify({ ...(body as Record<string, unknown>), idempotencyKey: key }),
  });
}
